import { motion, useReducedMotion } from "motion/react";

/* The header entrance the site already uses: the ambassador, about and
   pricing pages each animate their header this way, with the delay stepped
   per element so the block arrives in sequence rather than all at once.
   Same values as those three, in one place, so a new header only has to
   import it.

   Anyone who has asked for less motion gets the finished state immediately —
   the rest of the page reveal (see intro.css) already honours that. */
export function FadeIn({ children, delay = 0, className }) {
  const still = useReducedMotion();

  return (
    <motion.div
      className={className}
      initial={still ? false : { opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={
        still
          ? { duration: 0 }
          : { type: "spring", stiffness: 120, damping: 14, delay }
      }
    >
      {children}
    </motion.div>
  );
}

/* The same entrance, held until the element scrolls into view. Sections far
   enough down the page never show a mount animation — it has finished long
   before anyone reaches them — so those use this instead. Fires once. */
export function FadeInView({ children, delay = 0, className, amount = 0.4 }) {
  const still = useReducedMotion();

  return (
    <motion.div
      className={className}
      initial={still ? false : { opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={
        still
          ? { duration: 0 }
          : { type: "spring", stiffness: 120, damping: 14, delay }
      }
    >
      {children}
    </motion.div>
  );
}

export default FadeIn;
